export default __webpack_public_path__ + "static/media/feature-1.9fcabe22.png";